import { render, staticRenderFns } from "./InputSelectRemoteSuggestion.vue?vue&type=template&id=16444617"
import script from "./InputSelectRemoteSuggestion.vue?vue&type=script&lang=js"
export * from "./InputSelectRemoteSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports